//import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Transition from './Dialogs/Transition';

const styles = {
	row : {
		paddingBottom : 10,
	},
	label : {
		marginRight : 10,
	},
	value : {
		fontWeight : 600,
	},
	current : {

	},
	new : {
		marginTop : 20,
	},
	section : {
		margin : '30px 0px 10px 0px',
		textAlign : 'left',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
};

export default class DcStationDialog extends Component {

	constructor (props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	handleClose() {
		this.props.onClose();
	}

	handleDelete() {
		const stationId = this.props.station.stationId;
		this.props.removeStation({
			stationId,
			callback : function (err) {
				if (!err) { this.props.onClose(); }
			}.bind(this)
		});
	}

	render() {
		const { station} = this.props;

		const fields = [
			{ display : 'Station Number', key : 'number' },
			{ display : 'Station Name', key : 'name' },
			{ display : 'Contact Name', key : 'contactName' },
			{ display : 'Contact Phone Number', key : 'contactPhoneNumber' },
			{ display : 'Station Address', key : 'address' },
		];

		return (
			<Dialog
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
			>
				<DialogTitle>
					{station.number} - {station.name}
				</DialogTitle>
				<DialogContent>
					{fields.map(field => {
						return (
							<div key={field.key} style={styles.row}>
								<span style={styles.label}>{field.display}</span>
								<span style={styles.value}>{station[field.key]}</span>
							</div>
						);
					})}

					<div style={{padding:20, fontWeight : 900, fontSize : 18}}>
						Are you sure you want to delete this station?
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose}>
						Close
					</Button>
					<Button variant="contained" onClick={this.handleDelete} style={{backgroundColor : '#F44336', color : 'white'}}>
						Yes, Delete this station
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

DcStationDialog.propTypes = {
	open : PropTypes.bool,
	station : PropTypes.object.isRequired,
	onClose : PropTypes.func.isRequired,
	removeStation : PropTypes.func.isRequired,
};